// extracted by mini-css-extract-plugin
module.exports = {"modalWindow":"DownloadEntryFooter_modalWindow__2yFM2","userSelect":"DownloadEntryFooter_userSelect__3lqtt"};